<template>
  <div class="card-normal text-xs-center">
    <div v-if="carregando" class="carregando"><i class="el-icon-loading"></i></div>
    <div :class="carregando ? 'blur' : ''">
      <div class="card-content">
        <div class="avatar">
          <span class="avatar-ini" style="left:1px"><i class="far fa-clock"></i></span>
        </div>
        <h2>{{titulo}}</h2>
        <h3>{{dia.format('dddd')}} - {{dia.format('DD [de] MMMM')}}</h3>
        <div v-if="hist_dia.length === 0" class="py-4">
          <span style="opacity: .5;">Nenhum colaborador bateu ponto hoje.</span>
        </div>

        <el-row :gutter="30" class="flex">
          <el-col :xs="24" :sm="12" :md="8" v-for="(item, index) in hist_dia" :key="index">
            <div class="dia click" @click="$router.push(`colaborador/${item.uid}`)">
              <p class="data">{{item.colaborador.replace(/(([^\s]+\s\s*){3})(.*)/,"$1")}}</p>
              <el-row :gutter="30">
                <el-col v-for="(hora, index) in filtroArrayHora(item.horarios, (a,b) => !isEqual(a,b))"
                  :key="index" :span="12" :style="(hora.tipo === 'entrando') ? 'text-align: right' : 'text-align: left'">
                  <span class="hora">{{hora.horario}}</span>
                  <i class="fas" :class="(hora.tipo === 'entrando') ? 'fa-arrow-up verde' : 'fa-arrow-down vermelho'"></i>
                </el-col>
                <el-col v-for="(hora, index) in filtroArrayHora(item.horarios, isEqual)" :key="index"
                  :span="24">
                  <p class="justificativa">Horário justificado: {{`${parseInt(hora.minutos / 60)}h
                    ${('0' + (hora.minutos % 60)).slice(-2)}m`}}</p>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash';
import moment from 'moment';

export default {
  props: {
    dia: {
      type: Object,
      required: true
    },
    titulo: {
      type: String,
      default: 'Pontos do Dia'
    }
  },
  data: () => ({
    carregando: true,
    hist_dia: []
  }),
  created() {
    const ref = this.$db.ref('horarios');
    ref.on('value', snap => {
      this.hist_dia = [];

      const uid = Object.keys(snap.val());
      const horarios = Object.values(snap.val());
      const ano = this.dia.format('YYYY');
      const mes = this.dia.format('MM');
      const dia = this.dia.format('DD');

      horarios.forEach((element, index) => {
        if (element[ano]) if (element[ano][mes]) if (element[ano][mes][dia]) {
          const obj = {
            horarios: []
          };

          Object.values(element[ano][mes][dia]).forEach(item => {
            obj.colaborador = item.colaborador;
            obj.uid = uid[index];

            obj.horarios.push({
              horario: moment(item.data).format('HH:mm'),
              tipo: item.tipo,
              minutos: item.tipo === 'justificativa' ? item.minutos : null
            });
          });

          this.hist_dia.push(obj);
          this.hist_dia.sort((a, b) => {
            if (a.colaborador > b.colaborador) return 1;
            if (a.colaborador < b.colaborador) return -1;
            return 0;
          });
          this.carregando = false;
        }
      });

      this.carregando = false;
    });
  },
  methods: {
    isEqual,
    filtroArrayHora(arr, op) {
      return arr.filter(a => op(a.tipo, 'justificativa'));
    }
  }
};
</script>
